import React, { useEffect } from 'react';
import { useParams, Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS } from '../../constants/layout';

const LocaleGuard: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  const isValid = Boolean(lang && SUPPORTED_LANGS.includes(lang as any));

  useEffect(() => {
    if (isValid && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n, isValid]);

  if (!isValid) {
    return <Navigate to="/en" replace />;
  }

  return <Outlet />;
};

export default LocaleGuard;
